export enum BahfEvents {
  LOGINCLICKED = 'bahfLoginClicked',
  LOADED = 'bahfLoaded',
  LANGUAGE_SET = 'bahfLanguage',
  SEND_LANGUAGE = 'bahfSendLanguage',
  UPDATE_LANGUAGES = 'bahfUpdateLanguages',
}
